import * as React from 'react';

import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {generateTestId} from '@spaced-out/ui-design-system/lib/utils/qa';
import {EmptyState} from '@spaced-out/ui-design-system/lib/components/EmptyState';

import {TEST_ID} from '../../utils/testId';

import css from './availability-empty.css';


export const AvailabilityEmpty = () => {
  const {t} = useLabelTranslation();
  return (
    <EmptyState
      classNames={{wrapper: css.availabilityEmpty}}
      imageVariant="calendar"
      title={t(
        'No_available_date_time_found',
        'No available date & time found',
      )}
      testId={generateTestId({
        base: TEST_ID.BOOKING_FLOW,
        slot: 'availability-empty',
      })}
    />
  );
};
